
import "theme/moydom/less/pages/spravochnik.less";
import {
    Coordinate, DistanceTool,
    GeoJSON, Geometry, LineString,
    Map,
    Marker,
    Polygon,
    TileLayer,
    VectorLayer,
    OverlayLayer,
    Extent,
} from "maptalks";
import { ClusterLayer } from './maptalks-cluster';
import { CompassControl } from './maptalks-compass';
import 'maptalks.control.compass/css/maptalks.control.compass.css';
import { v4 as uuid } from 'uuid';
import {TILE_MOYDOM} from 'ui/map/config';
import { ThreeLayer } from "maptalks.three-without-vertextcolor";
import * as THREE from 'three';

// @ts-ignore
import { Sky } from "three/examples/jsm/objects/Sky";
// import { ThreeLayer } from "maptalks.three";
// import { v4 as uuid } from 'uuid';
// import * as THREE from 'three';


export default class MaptalksMap {
    private config: any;
    private map: Map;

    _createSky(): Sky {
        // Add Sky
        var sky = new Sky();
        sky.scale.setScalar(1000000);

        // GUI
        var effectController = {
            turbidity: 0,
            rayleigh: 0.5,
            mieCoefficient: 0.005,
            mieDirectionalG: 0.7,
            inclination: 0.47,
            azimuth: 0.25,
            exposure: 0.
        };

        const uniforms = sky.material.uniforms;
        uniforms['turbidity'].value = effectController.turbidity;
        uniforms['rayleigh'].value = effectController.rayleigh;
        uniforms['mieCoefficient'].value = effectController.mieCoefficient;
        uniforms['mieDirectionalG'].value = effectController.mieDirectionalG;

        var theta = Math.PI * (effectController.inclination - 0.5);
        var phi = 2 * Math.PI * (effectController.azimuth - 0.5);

        var sun = new THREE.Vector3();
        sun.x = Math.cos(phi);
        sun.y = Math.sin(phi) * Math.sin(theta);
        sun.z = Math.sin(phi) * Math.cos(theta);
        uniforms['sunPosition'].value.copy(sun);

        return sky;
    }

    constructor(element, config) {
        this.config = config;
        const polygons = new VectorLayer('p');
        const markers = new ClusterLayer('m', [])

        // TODO стоит описать структуру initData на ts
        const configCenter = config.initData.center;
        const center = new Coordinate(configCenter[1], configCenter[0]);

        const minZoom = config.initData.mapConfig.minZoom;
        const maxZoom = config.initData.mapConfig.maxZoom;

        let bounds = config.initData.mapConfig.bounds;

        if (bounds){
            bounds = new Extent(
                bounds.leftTop.x, bounds.leftTop.y,
                bounds.rightBottom.x, bounds.rightBottom.y
            );
        }

        const baseLayer = new TileLayer("tile", {
            urlTemplate: TILE_MOYDOM,
        });

        this.map = new Map(element, {
            center: center,
            zoom: 13,
            baseLayer,
            minZoom: minZoom,
            maxZoom: maxZoom,
            panAnimation: false,
            scaleControl: true,
            layers : [
                // baseLayer,
                polygons,
                markers,
            ],
        });

        if (bounds){
            this.map.setMaxExtent(bounds);
        }

        const compassControl = new CompassControl({
            position: 'top-right',
            backgroundColor: '#353e45', // 'rgba(235, 235, 235, .65)'
            transform: 'scale(1.2) translate(10%, 10%)',
            resetViewTriggers: 'click dblclick', // ['dblclick contextmenu', {duration: 500}]
        }).addTo(this.map);

        // added sky
        // const threeLayerSky = new ThreeLayer(uuid(), {
        //     forceRenderOnMoving: true,
        //     forceRenderOnRotating: true,
        // });
        // threeLayerSky.setZIndex(-1000);
        // threeLayerSky.prepareToDraw = (gl, scene, camera)  => {
        //
        //     var light = new THREE.DirectionalLight(0xffffff);
        //     light.position.set(0, -10, 10).normalize();
        //     camera.add(new THREE.PointLight("#fff", 2));
        //     scene.add(this._createSky());
        //     scene.rotation.x = -Math.PI / 2;
        // };
        // threeLayerSky.addTo(this.map);

        this.map.on('click', (e) => {
            this.map.identify({
                'coordinate' : e.coordinate,
                'layers' : [markers, polygons]
            }, function (geos: any[]) {
                const list = [];
                geos.forEach((g: any) => {
                    if (g instanceof LineString) {
                        list.push((g as any).properties.id);
                    } else if (g instanceof Polygon) {
                        list.push((g as any).properties.id);
                    } else if (g.children) {
                        for (const subMarker of g.children) {
                            list.push(subMarker.properties.id);
                        }
                    }
                });
                if (list.length > 0) {
                    config.event.onChoiceElem(list);
                }
            });
        });

    }

    _makeSvgIcon(icon) {
        const iconUrl = 'data:image/svg+xml;base64,' + btoa(icon);

        return {
            markerFile: iconUrl,
            markerPathWidth : 12,
            markerPathHeight : 33,
            markerDy : 6,
            markerDx : 0
        }
    }

    _render(geoObject) {
        GeoJSON.toGeometry(geoObject, (geometry: Geometry) => {
            if (geometry instanceof Polygon) {
                const color = (geometry as any).properties.color || '#6299ff'
                geometry.setSymbol({
                    lineColor: color,
                    lineWidth: 1,
                    polygonFill: color,
                    polygonOpacity: 0.5
                })
                geometry.addTo(this.map.getLayer('p') as OverlayLayer);

            } else if (geometry instanceof Marker) {
                const _properties = (geometry as any).properties;
                const icon = _properties.icon;
                if (icon) {
                    geometry.setSymbol(this._makeSvgIcon(icon));
                    geometry.on('click', () => {
                        this.config.event.onChoiceElem(_properties.id);
                    })

                    const layer = this.map.getLayer('m') as ClusterLayer;
                    layer.addMarker(geometry);
                }
            } else if (geometry instanceof LineString) {
                const color = (geometry as any).properties.color || '#6299ff'
                geometry.setSymbol({
                    lineColor: color,
                    lineWidth: 2,
                    polygonFill: color,
                    polygonOpacity: 0.5
                })
                geometry.addTo(this.map.getLayer('p') as OverlayLayer);
            }
        });
    }

    init(objects) {
        objects.forEach((object) => {
            this._render(JSON.parse(object.geoObject));
        });

        this.map.panTo(this.map.getCenter());
    }


    refresh() {
    }
}

